import React from 'react';
import { PropTypes } from 'prop-types';

const OnlineForm = ({ title, formType, handleClick, isProcessing }) => (
  <div className="online-form card form-box">
    <section>
      <h1>{title}</h1>
      <p>Click the button to start filling out the form</p>
      <div>
        <button
          type="button"
          className={ `btn btn-primary ${ isProcessing ? 'loading' : '' }` }
          onClick={ () => handleClick(formType) }
        >Go to the form</button>
      </div>
    </section>
  </div>
);

OnlineForm.propTypes = {
  title: PropTypes.string.isRequired,
  formType: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  isProcessing: PropTypes.bool,
};

OnlineForm.defaultProps = {
  isProcessing: false
};

export default OnlineForm;
